import { styled } from "src/ccl/stitches";

export const Img = styled("img", {
  maxWidth: "100%",
  display: "block",
});
